import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { transactionhistory } from '../../models/transactionhistory/transactionhistorymodal';
@Injectable()
export class TransactionHistoryService {
  // Store
  private transHistorySelectionIndex = new ReplaySubject<any>();
  private transHistory = new ReplaySubject<any>();
  private transbenifcaryDetail = new ReplaySubject<any>();

  constructor(private http: Http, private utilserv: utilityService) {}
  // 1 Envolpe for
  gettransactionlistservice(orderid: String, BenificiaryId: String) {
    return this.utilserv.soapPostwithoutAction(this.gettransactionlistenvolpe(orderid, BenificiaryId), AppSettings.transactionService + '/GetOrder');
  }
  gettransactionlistenvolpe(orderid: String, BenificiaryId: String) {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                                                                               <s:Header>
                                                                                 <a:Action s:mustUnderstand="1">http://tempuri.org/ITransactionService/GetOrder</a:Action>
                                                                                 <a:MessageID>urn:uuid:56ced965-57f6-46cc-8bcb-b61b44a87284</a:MessageID>
                                                                                 <a:ReplyTo>
                                                                                   <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                                                                                 </a:ReplyTo>
                                                                               </s:Header>
                                                                               <s:Body>
                                                                                 <OrderRequest xmlns="http://tempuri.org/">
                                                                                 <BenificiaryId>${BenificiaryId}</BenificiaryId>
                                                                                   <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                                                                                   <OrderNo>${orderid}</OrderNo>
                                                                                   <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap"
                                                                                    xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                                                                     <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
                                                                                     <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                                                                                   </Session>
                                                                                 </OrderRequest>
                                                                               </s:Body>
                                                                             </s:Envelope>`;

    // console.log(envelope);
    return envelope;
  }
  gettransactionlPin(orderid: String) {
    return this.utilserv.soapPostwithoutAction(this.gettransactionPinenvolpe(orderid), AppSettings.transactionService + '/GetOrder');
  }
  gettransactionPinenvolpe(orderid: String) {
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                          <s:Header>
                              <a:Action s:mustUnderstand="1">http://tempuri.org/ITransactionService/GetPIN</a:Action>
                              <a:MessageID>urn:uuid:14bdfdd8-c1d6-4481-8ba1-668e25c3ce3a</a:MessageID>
                                <a:ReplyTo>
                                  <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                              </a:ReplyTo>
                          </s:Header>
                          <s:Body>
                          <PINRequest xmlns="http://tempuri.org/">
                            <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                            <OrderID>${orderid}</OrderID>
                            <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap"
                                    xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                              <d4p1:T1></d4p1:T1>
                              <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
                            </Session>
                          </PINRequest>
                        </s:Body>
                      </s:Envelope>`;
    return envelope;
  }
  getOrderItemStatus(orderidList: any) {
    return this.utilserv.soapPostwithoutAction(this.getOrderItemStatusEnvolpe(orderidList), AppSettings.OrderProcessingService);
  } 
  getOrderItemStatusEnvolpe(orderidList: any) {

    let envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
    <s:Header>
      <a:Action s:mustUnderstand="1">http://tempuri.org/IOrderProcessingService/GetOrderItemStatus</a:Action>
      <a:MessageID>urn:uuid:db13d91f-ae1b-4120-bcd8-046764f6ebf2</a:MessageID>
      <a:ReplyTo>
        <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
      </a:ReplyTo>
    </s:Header>
    <s:Body>
      <OrderStatusRequest xmlns="http://tempuri.org/">
        <Items xmlns:d4p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
        `;
    orderidList.forEach(element => {
      envelope += '<d4p1:string>' + element + '</d4p1:string>';
    });
    envelope += `</Items>
        <LanguageCode>${sessionStorage.langCode}</LanguageCode>
        <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
          <d4p1:T1></d4p1:T1>
          <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
        </Session>
      </OrderStatusRequest>
    </s:Body>
  </s:Envelope>
  `;
    return envelope;
  }



  getTransferDetailV2Service(orderid: String, BenificiaryId: String) {
    return this.utilserv.soapPostwithoutAction(this.getTransferDetailV2Envelope(orderid, BenificiaryId), AppSettings.transactionService + '/GetTransferDetailV2');
  }


    getTransferDetailV2Envelope(orderid: String, BenificiaryId: String) {

    let envelope = `
    <s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
      <s:Header>
        <a:Action s:mustUnderstand="1">http://tempuri.org/ITransactionService/GetTransferDetailV2</a:Action>
        <a:MessageID>urn:uuid:dca63cb9-2d0d-4df7-b031-500b80df5786</a:MessageID>
        <a:ReplyTo>
          <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
        </a:ReplyTo>
      </s:Header>
      <s:Body>
        <OrderRequest xmlns="http://tempuri.org/">
          <BenificiaryId>${BenificiaryId}</BenificiaryId>
          <LanguageCode>${sessionStorage.langCode}</LanguageCode>
          <OrderNo>${orderid}</OrderNo>
          <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap"
          xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
            <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
          </Session>
        </OrderRequest>
      </s:Body>
    </s:Envelope>
    `;
    return envelope;
  }

  settransactionhistorySelectIndex(dataValues: any) {
    this.transHistorySelectionIndex.next(dataValues);
  }

  gettransactionhistorySelectIndex(): Observable<any> {
    return this.transHistorySelectionIndex.asObservable();
  }

  settransactionhistoryData(dataValues: any) {
    const obj: any = this.transHistory;
    obj._events = [];
    this.transHistory.next(dataValues);
  }

  gettransactionhistoryData(): Observable<any> {
    return this.transHistory.asObservable();
  }
  ///Store Data
  settransbenifcaryDetailData(dataValues: any) {
    const obj: any = this.transbenifcaryDetail;
    obj._events = [];
    this.transbenifcaryDetail.next(dataValues);
  }

  gettransbenifcaryDetailData(): Observable<any> {
    return this.transbenifcaryDetail.asObservable();
  }
  // Order Section
  getorderreceiptservice(orderid: String, receiptType) {
    let receiptURL = AppSettings.orderReceiptURL;
    if (receiptType === 'PDF') {
      receiptURL += 'GetOrderReceipt';
    } else {
      receiptURL += 'SendOrderReceipt';
    }
    return this.utilserv.restPost(this.getorderreceiptenvolpe(orderid, 'PDF'), receiptURL);
  }
  getorderreceiptenvolpe(orderid: String, receiptType) {
    // In case of Base64  use PDF
    // In case of URL  use PDFURL.
    const envelope = `{
      "OrderNumber":"${orderid}",
      "LanguageCode":"${sessionStorage.langCode}",
      "Type":"${receiptType}",
      "Session": {
        "T1":"${sessionStorage.T1}" ,
        "T2":"${sessionStorage.T2}"
      }
    }`;
    return envelope;
  }

  cancelorderservice(orderid: String) {
    return this.utilserv.soapPostwithoutAction(this.cancelorderenvolpe(orderid), AppSettings.OrderProcessingService);
  }

  cancelorderenvolpe(orderid: String) {
    const envelope = `<s:Envelope xmlns:s="http://www.w3.org/2003/05/soap-envelope" xmlns:a="http://www.w3.org/2005/08/addressing">
    <s:Header>
       <a:Action s:mustUnderstand="1">http://tempuri.org/IOrderProcessingService/CancelOrder</a:Action>
       <a:MessageID>urn:uuid:3205d1bd-affd-4f96-8904-0c3df24f8a3d</a:MessageID>
       <a:ReplyTo>
          <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
       </a:ReplyTo>
    </s:Header>
    <s:Body>
       <CancelOrderRequest xmlns="http://tempuri.org/">
          <LanguageCode>${sessionStorage.langCode}</LanguageCode>
          <OrderNumber>${orderid}</OrderNumber>
          <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
             <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
             <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
          </Session>
       </CancelOrderRequest>
    </s:Body>
 </s:Envelope>
 `;
    return envelope;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/transaction/transaction-history.service.ts